<header>
  <nav class="bottom-header">
    <ul>
      <li class="image-container">
        <h2 class="titulo">{{ pageTitle }}</h2>
        <img [src]="bannerImage || '../../../assets/images/sem-imagem.png'" alt="Imagem de {{ pageTitle }}" />
      </li>
    </ul>
  </nav>
</header>

<div class="boxContainer">
  <div class="firstBox">
    <ul class="configuracoesList" style="margin-left: 38px;">
      <ng-container *ngFor="let item of paginatedItems">
        <a (click)="selectItem(item)">
          <li class="configuracoesList_item" [ngClass]="{'active': isActive(item)}">
            <img *ngIf="item.icon.indexOf('fa-') === -1; else iconTemplate" [src]="item.icon"
              class="configuracoesList_item_icon" />
            <ng-template #iconTemplate>
              <i [ngClass]="item.icon" class="fa-icon"></i>
            </ng-template>
            <span class="title">{{ item.name }}</span>
          </li>
        </a>
      </ng-container>
    </ul>

    <div class="card-informacao filter-todos_item_container p-10 d-flex flex-column justify-content-between">
      <form>
        <div class="info-container d-flex flex-column align-items-start">
          <div class="info-item">
            <h4>{{ filtro }}</h4>
            <hr>
            <p>{{ info }}</p>
          </div>
        </div>
      </form>
    </div>

    <div class="descricao">
      <p>
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Nemo nihil ut reprehenderit
        voluptate ipsam commodi quam voluptatum iste, quasi explicabo inventore recusandae blanditiis
        perspiciatis, vel neque magnam non tempore quisquam.
      </p>
    </div>

    <div class="destaques">
      <div class="destaques-titulo">
        <h2 class="boxContainer_titulo">Destaques</h2>
      </div>
      <app-carousel-destaques></app-carousel-destaques>
    </div>
    <div class="mapa-rotas" style="margin-left: 38px;">
      <app-mapa-rota-onibus [locations]="locations"></app-mapa-rota-onibus>
    </div>
  </div>

  <div class="secondBox">
    <div class="card-informacao filtro-solar_item_container p-10 d-flex flex-column justify-content-between">
      <form>
        <div class="info-container d-flex flex-column align-items-start">
          <div class="info-area">
            <i class="icone fa-solid fa-location-dot"></i>
            <div class="info-text">
              <h5>Endereço</h5>
              <p>{{ address }}</p>
              <hr>
            </div>
          </div>
          <div class="info-area">
            <i class="fa-solid fa-up-right-and-down-left-from-center"></i>
            <div class="info-text">
              <p>Área</p>
              <p>{{ area }}</p>
            </div>
          </div>
          <div class="info-area">
            <i class="fa-regular fa-clock"></i>
            <div class="info-text">
              <p>Funcionamento</p>
              <p>{{ hours.weekday }}</p>
              <p>{{ hours.saturday }}</p>
              <p>{{ hours.sunday }}</p>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="clima">
      <app-clima-widget></app-clima-widget>
    </div>
  </div>
</div>